import { render, staticRenderFns } from "./StepLocate.vue?vue&type=template&id=77c06f98&scoped=true&"
import script from "./StepLocate.vue?vue&type=script&lang=js&"
export * from "./StepLocate.vue?vue&type=script&lang=js&"
import style0 from "./StepLocate.vue?vue&type=style&index=0&id=77c06f98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c06f98",
  null
  
)

export default component.exports